import { forwardRef, type Ref, type SVGProps } from "react";
const IconTreeBenchFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={13} height={7} x={4} y={16} rx={1} />
    <rect width={2} height={19} x={23} y={11} rx={1} />
    <path d="M29.38 10.91a7 7 0 0 0-1.86-2.31A5 5 0 0 0 28 6.5 4.27 4.27 0 0 0 24 2a3.92 3.92 0 0 0-3.32 2 5 5 0 0 0-.41 4.12 4 4 0 0 0 .21.5A6.41 6.41 0 0 0 18 13.7a6.22 6.22 0 0 0 5 6.21V12a1 1 0 0 1 2 0v7.91a6.22 6.22 0 0 0 5-6.21 6.1 6.1 0 0 0-.62-2.79M18 25H3a1 1 0 0 0 0 2h1v2a1 1 0 0 0 2 0v-2h9v2a1 1 0 0 0 2 0v-2h1a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconTreeBenchFilledSVG);
ForwardRef.displayName = "IconTreeBenchFilled";
export { ForwardRef as IconTreeBenchFilled };
